import _ from 'lodash';
import {
    FETCH_AI_CHATBOT_THREADS,
    CLEAN_AI_CHATBOT_THREADS,
    DELETE_AI_CHATBOT_THREAD,
    DELETE_AI_CHATBOT_THREADS,
} from './types';
import { request, __ } from '../functions';

export const fetchAiChatbotThreads = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/ai-chatbot-threads', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_AI_CHATBOT_THREADS, payload: data });
    });
};

export const deleteAiChatbotThread = (screen, id) => {
    return dispatch => request(`/ai-chatbot-threads/delete/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať konverzáciu'));
            return;
        }

        screen.showSnackbar('success', __('Konverzácia bola zmazaná'));

        dispatch({ type: DELETE_AI_CHATBOT_THREAD });
    });
};

export const deleteAiChatbotThreads = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-chatbot-threads/multiDelete/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať konverzácie'));
            return;
        }

        screen.showSnackbar('success', __('Konverzácie boli zmazané'));

        dispatch({ type: DELETE_AI_CHATBOT_THREADS });
    });
};

export const cleanAiChatbotThreads = () => ({ type: CLEAN_AI_CHATBOT_THREADS });
